import StudyConfirmAuthWrapper from './StudyConfirmAuthWrapper';

export default StudyConfirmAuthWrapper;
